import {StyleRepository} from '@domain/model/Style/StyleRepository';

const DeleteQuizId = (repository: StyleRepository): Promise<void> => {
  return repository.deleteQuizId();
};

export {DeleteQuizId};
